import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapplication',
  templateUrl: './webapplication.component.html',
  styleUrls: ['./webapplication.component.scss']
})
export class WebapplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
